<div class="log-data-display">
  @if (parsedData) {
    <!-- Handle plain JSON object display -->
    @if (isObject(parsedData)) {
      <div class="data-table">
        @for (key of getObjectKeys(parsedData); track key) {
          <div class="data-row">
            <div class="data-label">{{ getFieldLabel(key) }}:</div>
            <div class="data-value">{{ formatValue(parsedData[key], key) }}</div>
          </div>
        }
      </div>
    }
    <!-- Handle plain string or other types -->
    @if (!isObject(parsedData)) {
      <div class="data-text">{{ parsedData }}</div>
    }
  }

  <!-- Fallback for no data -->
  @if (!parsedData) {
    <div class="data-empty">Brak danych do wyświetlenia</div>
  }
</div>
